import React from 'react';

import { Connector } from 'lumapps-sdk-js';

import { SelectTextField } from '@lumapps/combobox/components/SelectTextField';
import { useTranslate } from '@lumapps/translations';

import { useExtensionConnectorList } from '../../hooks/useExtensionConnectorList';
import { MARKETPLACE } from '../../keys';
import { ExtensionProps } from '../../legacy-types';

export interface ConnectorSelectProps {
    extensionId: string;
    initConnectorId?: string;
    sitesId?: string;
    value?: Connector;
    extension?: ExtensionProps;
    onChange: (value?: Connector) => void;
    onInit?: (extension?: ExtensionProps, connector?: Connector) => void;
}

export const ConnectorSelect = ({
    extensionId,
    initConnectorId,
    extension,
    sitesId,
    value,
    onChange,
    onInit,
}: ConnectorSelectProps) => {
    const { translateKey } = useTranslate();
    let selectedConnector: Connector | undefined = value;
    const query = useExtensionConnectorList({
        extensionId,
        site: sitesId,
    });

    if (initConnectorId && query.baseLoadingStatus === 'idle' && !value) {
        selectedConnector = query.items.find((item) => item.id === initConnectorId);
        if (onInit) {
            onInit(extension, selectedConnector);
        }
    }

    return (
        <SelectTextField<Connector>
            autoFilter
            selectionType="single"
            id="connector-picker"
            name="connector-picker"
            scope="connector-picker"
            options={query.items}
            label={translateKey(MARKETPLACE.CONNECTOR)}
            placeholder={translateKey(MARKETPLACE.SELECT_CONNECTOR)}
            value={selectedConnector}
            getOptionId="id"
            getOptionName="name"
            onChange={onChange}
            isDisabled={query.baseLoadingStatus === 'loading'}
            hasClearButton={false}
        />
    );
};
